<template>
    <div>
      <h1>{{scanText}}</h1>
    </div>
</template>
<script>
export default {
  name: 'Sandbox',
  data () {
    return {
      returnedNumber: 0,
      visible: false,
      layout: 'compact',
      input: null,
      scanText: '',
      options: {
        useKbEvents: false,
        preventClickEvent: false
      }
    }
  },
  methods: {
    accept (text) {
      this.hide()
    },
    show (e) {
      this.input = e.target
      this.layout = e.target.dataset.layout
      if (!this.visible) { this.visible = true }
    },
    hide () {
      this.visible = false
    },
    async onScan (s) {
      this.scanText = s
    }
  }

}
</script>
